<template>
  <div class="map-q relative">
    <template v-if="mapPattern">
      <map-pattern :issue="issue" />
    </template>
    <template v-else-if="textPattern">
      <text-map :issue="issue" />
    </template>
    <div v-if="view" class="absolute inset-0 z-10"></div>
  </div>
</template>

<script>
import MapPattern from '@/questions/components/map/MapPattern'
import TextMap from '@/questions/components/map/TextMap'

export default {
  name: 'MapQ',
  changeExpr: 'issue.value',
  components: { TextMap, MapPattern },
  computed: {
    pattern() {
      return this.question.issue.displayType
    },
    textPattern() {
      return this.pattern === 0
    },
    mapPattern() {
      return this.pattern === 1
    }
  }
}
</script>
